import type { PiledUpJob } from '../../../lib/piled-up-jobs';
import { useWorkspaceIcon } from '../../../lib/workspaces';
import { AgentDot } from '../../AgentDot';
import { WorkspaceBadge } from '../WorkspaceBadge';

/**
 * A job's leading avatar: the agent's identity dot when assigned, otherwise the WORKSPACE badge — clipped
 * to a circle so it reads as the same shape and left-edge crop as the dot it stands in for. 1:1 with
 * native's `PiledUpAvatar` (iOS `PiledUpJobs.swift`, Android `PiledUpJobs.kt`).
 *
 * The workspace badge resolves its icon the way every other space avatar does; the job's own baked
 * `workspaceIcon` is only the fallback for the window before the workspace list has merged.
 */
export function PiledUpAvatar({ job, size }: { job: PiledUpJob; size: number }) {
  // Resolved by id from the shared workspace list, so an icon edited elsewhere repaints this card too.
  const liveIcon = useWorkspaceIcon(job.workspaceId);
  if (job.agentId) return <AgentDot id={job.agentId} size={size} />;
  return (
    <WorkspaceBadge
      ws={{ id: job.workspaceId, name: job.workspaceName, icon: liveIcon }}
      size={size}
      shape="circle"
      fallbackIcon={job.workspaceIcon || undefined}
    />
  );
}
